import api from "@/api"

const state = {
  careers: [],
  career: {},
  submissions: [],
  submission: {}
}

const actions = {
  getCareerList({ commit }, params) {
    return api.career.careerList(params).then((response) => {
      commit("setCareers", response.data)
      return response
    })
  },
  getCareer({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      api.career.careerDetail(id).then(
        (response) => {
          commit("setCareer", response.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  createCareer({ commit }, payloads) {
    return new Promise((resolve, reject) => {
      api.career.careerCreate(payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  updateCareer({ commit }, { payloads, id }) {
    return new Promise((resolve, reject) => {
      api.career.careerUpdate(payloads, id).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  deleteCareer({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.career.careerDelete(id).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getSubmissionsList({ commit }, params) {
    return api.career.submissionsList(params).then((response) => {
      commit("setSubmissions", response.data)
      return response
    })
  },
  getSubmission({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      api.career.submissionDetail(id).then(
        (response) => {
          commit("setSubmission", response.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  updateSubmissionStatus({ commit }, { id, payloads }) {
    return new Promise((resolve, reject) => {
      api.career.updateSubmissionStatus(id, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  deleteSubmission({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.career.deleteSubmission(id).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getCareerSubmissions({ commit }, careerId) {
    return new Promise((resolve, reject) => {
      api.career.careerSubmissions(careerId).then(
        (response) => {
          commit("setSubmissions", response.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}

const mutations = {
  setCareers(state, value) {
    state.careers = value
  },
  setCareer(state, value) {
    state.career = value
  },
  setSubmissions(state, value) {
    state.submissions = value
  },
  setSubmission(state, value) {
    state.submission = value
  }
}

const getters = {
  careers: (state) => state.careers,
  career: (state) => state.career,
  submissions: (state) => state.submissions,
  submission: (state) => state.submission
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
